import { Close } from "@mui/icons-material";
import { Button, Grid, Paper } from "@mui/material";
import PaperButton from "components/buttons/PaperButton";
import CustomText from "components/typography/CustomText";
import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { openLoading } from "store/reducers/tools";
import ForgotPasswordForm from "./ForgotPasswordForm";

export default function ForgotPasswordComponent() {
  const history = useHistory();
  const formRef = useRef();
  const [data, setData] = useState({});

  const handleSubmit = () => {
    const submitData = formRef.current.prepare();
    if (submitData) {
      openLoading(true);
      setTimeout(() => {
        openLoading(false);
        handleFinish();
      }, 3000);
    }
  };

  const handleFinish = () => {
    history.push("/");
  };

  return (
    <div>
      <Grid container direction="column">
        <Grid item>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <CustomText variant="h6">Reset Password</CustomText>
            </Grid>
            <Grid item>
              <PaperButton onClick={handleFinish}>
                <Close fontSize="large" />
              </PaperButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid item className="mt-4">
          <Paper className="p-10">
            <Grid container spacing={2} direction="column">
              <Grid item>
                <ForgotPasswordForm
                  ref={formRef}
                  data={data ?? {}}
                  onChange={setData}
                  type="state"
                />
              </Grid>
              <Grid item>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  size="large"
                  fullWidth
                >
                  Forgot Password
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
